export default {"src":"/_next/static/media/link-icon.7c764d94.svg","height":19,"width":19};